$(function() {
  // SP時のみアコーディオン
  $('.js-acTitleSp').on('click', function() {
    if ($('body').css('min-width') != '1060px') {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open');
        $(this).next('.js-acContentsSp').removeClass('is-open');
        // webinar 詳細ボタン用
        if ($(this).hasClass('js-webinarDetailAc')) {
          $(this).children('span').text('詳細');
        }
      } else {
        $(this).addClass('is-open');
        $(this).next('.js-acContentsSp').addClass('is-open');
        // webinar 詳細ボタン用
        if ($(this).hasClass('js-webinarDetailAc')) {
          $(this).children('span').text('閉じる');
        }
      }
    }
  })

  // commonAc
  $('.js-acTitleTrigger').on('click', function() {
    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open')
      $(this)
        .next('.js-acContentsBody')
        .removeClass('is-open')
    } else {
      $(this).addClass('is-open')
      $(this)
        .next('.js-acContentsBody')
        .addClass('is-open')
    }
  })
})
